import { yupResolver } from '@hookform/resolvers/yup';
import { Stack } from '@mui/material';
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonWithLoader, ConnectedTextField } from 'shared/components';
import * as yup from 'yup';

import { useSubmitSupportRequestMutation } from '../../hooks';

interface QuestionFormData {
    email: string;
    question: string;
}

const schema = yup.object({
    email: yup.string().required().email(),
    question: yup.string().required().max(1000).trim()
});

export default function QuestionForm() {
    const { t } = useTranslation('auth', { keyPrefix: 'loginHelp.needHelp' });
    const { t: tSendLink } = useTranslation('auth', { keyPrefix: 'loginHelp.sendLink' });

    const methods = useForm<QuestionFormData>({
        defaultValues: { email: '', question: '' },
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    const { handleSubmit, reset, control } = methods;
    const { mutate: submitSupportRequest, isPending } = useSubmitSupportRequestMutation();

    const onSubmit = useCallback((data: QuestionFormData) => {
        submitSupportRequest(
            { email: data.email.trim(), question: data.question.trim() },
            { onSuccess: () => reset() }
        );
    }, [ submitSupportRequest, reset ]);

    return (
        <FormProvider { ...methods }>
            <form onSubmit={ handleSubmit(onSubmit) }>
                <Stack spacing={ 2 }>
                    <ConnectedTextField
                        name="email"
                        control={ control }
                        label={ tSendLink('emailLabel') }
                        placeholder={ tSendLink('emailPlaceholder') }
                        size="small"
                        fullWidth
                    />

                    <ConnectedTextField
                        name="question"
                        control={ control }
                        label={ t('questionLabel') }
                        placeholder={ t('questionPlaceholder') }
                        multiline
                        fullWidth
                        minRows={ 3 }
                    />

                    <ButtonWithLoader
                        type="submit"
                        variant="contained"
                        loading={ isPending }
                    >
                        { t('button') }
                    </ButtonWithLoader>
                </Stack>
            </form>
        </FormProvider>
    );
}
